import { Button, Col, Form, Input, Row, Space, Switch, notification } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getModule, saveModule, updateModule } from "../../data";

const { TextArea } = Input;

const ModuleForm = () => {
    const [form] = Form.useForm();
    let history = useHistory()
    let { id } = useParams()

    const onFinish = async (values) => {
        if (id == 0) {
            const response = await saveModule(values)
            if (response) {
                history.push({ pathname: "/modules" });
                notification.open({ message: 'Module has been added successfully', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
            } else {
                notification.open({ message: 'Unable to add module', icon: <CloseCircleOutlined style={{ color: 'red' }} /> })
            }
        }
        else {
            const response = await updateModule(id, values)
            if (response) {
                history.push({ pathname: "/modules" });
                notification.open({ message: 'Module has been updated successfully', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
            } else {
                notification.open({ message: 'Unable to update module', icon: <CloseCircleOutlined style={{ color: 'red' }} /> })
            }
        }
    }

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const loadData = async (id) => {
        if (id > 0) {
            const response = await getModule(id)
            if (response !== null) {
                form.setFieldsValue({ ...response })
            }
        }
    }

    useEffect(() => {
        loadData(id)
    }, [])

    return (
        <>
            <Form
                layout={'vertical'}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ is_active: true }}
                form={form}>
                <Row gutter={16} >
                    <Col span={6}></Col>
                    <Col span={12} >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Name" name='name' rules={[
                                    {
                                        required: true,
                                        message: 'Name is required',
                                    }]}>
                                    <Input placeholder="Module Name" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Price" name='price' rules={[
                                    {
                                        required: true,
                                        message: 'Price is required',
                                    }]}>
                                    <Input placeholder="Price" type="number" step={0.01} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Description" name='description'>
                                    <TextArea rows={3} placeholder="Description" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="is_active" label="Active" valuePropName="checked">
                                    <Switch
                                        checkedChildren={<CheckOutlined />}
                                        unCheckedChildren={<CloseOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Item>
                                <Space>
                                    <Button htmlType="submit" type="primary">Submit</Button>
                                    <Button onClick={() => history.goBack()} type="primary">Cancel</Button>
                                </Space>
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col span={6}></Col>
                </Row>
            </Form>
        </>
    )
}

export default ModuleForm
